
import { defineComponent } from 'vue'
import moment from 'moment'
import ChatChannelIcon from '@/components/chisai/GCB2/chat/ChatChannelIcon.vue'
import { trackMultichatOpen } from '@/helpers/gcb2/multichatAnalytics'
import {
    avatarColor,
    getChannelFilterColor,
    getChannelLabel as resolveChannelLabel,
    initials,
    providerToChannelKey,
} from '@/helpers/gcb2/chatChannels'
import {
    ChatPopupNotification,
    useChatNotificationsStore,
} from '@/store/stores/chatNotifications'

export default defineComponent({
    name: 'ChatPopupNotifications',
    components: {
        ChatChannelIcon,
    },
    computed: {
        notifications(): ChatPopupNotification[] {
            return useChatNotificationsStore().notifications
        },
    },
    mounted() {
        document.addEventListener('visibilitychange', this.onVisibilityChange)
    },
    beforeDestroy() {
        document.removeEventListener('visibilitychange', this.onVisibilityChange)
    },
    methods: {
        onVisibilityChange() {
            const store = useChatNotificationsStore()
            if (document.hidden) {
                store.pauseAll()
            } else {
                store.resumeAll()
            }
        },
        getInitials(name?: string) {
            return initials(name)
        },
        getAvatarColor(notification: ChatPopupNotification) {
            return avatarColor(String(notification.chatId || notification.title || ''))
        },
        getChannelColor(notification: ChatPopupNotification) {
            return getChannelFilterColor(providerToChannelKey(notification.provider))
        },
        getChannelLabel(provider?: string) {
            return resolveChannelLabel(provider)
        },
        formatTime(timestamp?: string) {
            if (!timestamp) return ''
            return moment(timestamp).format('HH:mm')
        },
        closeNotification(notification: ChatPopupNotification) {
            useChatNotificationsStore().remove(notification.id)
        },
        openNotification(notification: ChatPopupNotification) {
            useChatNotificationsStore().remove(notification.id)
            trackMultichatOpen('popup')
            this.$router
                .push({
                    path: `/project/${notification.projectId}/GCB2`,
                    query: {
                        section: 'chat',
                        chatId: notification.chatId,
                        fs: '1',
                    },
                })
                .catch(() => {})
        },
    },
})
